import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    AddCircleOutline,
    Cancel,
    Check,
    Undo,
} from '@mui/icons-material';

import PermissionGuard, { HasPermissions } from '../../contexts/PermissionContext';
import SecondaryButton from '../buttons/SecondaryButton';
import SettingsTextField from '../textfield/SettingsTextField';
import SettingsCheckBox from '../checkbox/SettingsCheckBox';
import SettingsChipTextField from '../textfield/SettingsChipTextField';


function EditorialEmailRecipientsSettings({ schema={}, settings={}, setSettings = () => {} }) {

    const [editorialEmailRecipientsSettings, setEditorialEmailRecipientsSettings] = useState(settings);
    useEffect(() => {
        setEditorialEmailRecipientsSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(editorialEmailRecipientsSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setEditorialEmailRecipientsSettings(newSettings);
        console.log(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
                width='100%'
            >
                <Typography
                    variant="h6"
                >
                    Editorial Clearance
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    p={1}
                    sx={{
                        border: '1px solid rgba(92, 92, 92, 1)',
                        borderRadius: 3,
                        '&:hover': {
                            border: HasPermissions(schema?.permissions?.write) && '1px solid rgba(139, 142, 146, 1)'
                        },
                        transition: 'border 0.15s ease-out',
                    }}
                >
                    <SettingsTextField
                        description={`Number of approvals required from individual editiorial staff before a card is marked approved for clearance.`}
                        disabled={!HasPermissions(schema?.permissions?.write)}
                        label={schema?.data?.required_approvals?.label ?? 'Required Approvals for Clearance'}
                        onChange={(value) => handleChange('required_approvals', value)}
                        original={settings?.required_approvals ?? ''}
                        value={editorialEmailRecipientsSettings?.required_approvals ?? ''}
                    />
                    <SettingsChipTextField
                        description={`List of email addresses to receive editorial approval notifications.`}
                        disabled={!HasPermissions(schema?.permissions?.write)}
                        label='Email Addresses'
                        onChange={(values) => handleChange('card_clearance_emails', {...editorialEmailRecipientsSettings?.card_clearance_emails, email: values})}
                        original={settings?.card_clearance_emails?.email ?? []}
                        values={editorialEmailRecipientsSettings?.card_clearance_emails?.email ?? []}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default EditorialEmailRecipientsSettings;